import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["className"],
      _excluded2 = ["className"],
      _excluded3 = ["className"],
      _excluded4 = ["className"],
      _excluded5 = ["className"],
      _excluded6 = ["className"],
      _excluded7 = ["className"],
      _excluded8 = ["className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import { cn } from '@/shadcn/lib/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const Table = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className = ''
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx("div", {
    className: "relative w-full overflow-auto",
    children: /*#__PURE__*/_jsx("table", _objectSpread({
      ref: ref,
      className: cn('w-full caption-bottom text-sm', className)
    }, props))
  });
});
Table.displayName = 'Table';
const TableHeader = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className = ''
  } = _ref2,
      props = _objectWithoutProperties(_ref2, _excluded2);

  return /*#__PURE__*/_jsx("thead", _objectSpread({
    ref: ref,
    className: cn('[&_tr]:border-b', className)
  }, props));
});
TableHeader.displayName = 'TableHeader';
const TableBody = /*#__PURE__*/React.forwardRef((_ref3, ref) => {
  let {
    className = ''
  } = _ref3,
      props = _objectWithoutProperties(_ref3, _excluded3);

  return /*#__PURE__*/_jsx("tbody", _objectSpread({
    ref: ref,
    className: cn('[&_tr:last-child]:border-0', className)
  }, props));
});
TableBody.displayName = 'TableBody';
const TableFooter = /*#__PURE__*/React.forwardRef((_ref4, ref) => {
  let {
    className = ''
  } = _ref4,
      props = _objectWithoutProperties(_ref4, _excluded4);

  return /*#__PURE__*/_jsx("tfoot", _objectSpread({
    ref: ref,
    className: cn('border-t bg-neutral-100/50 font-medium [&>tr]:last:border-b-0 dark:bg-neutral-800/50', className)
  }, props));
});
TableFooter.displayName = 'TableFooter';
const TableRow = /*#__PURE__*/React.forwardRef((_ref5, ref) => {
  let {
    className = ''
  } = _ref5,
      props = _objectWithoutProperties(_ref5, _excluded5);

  return /*#__PURE__*/_jsx("tr", _objectSpread({
    ref: ref,
    className: cn('border-b transition-colors hover:bg-neutral-100/50 data-[state=selected]:bg-neutral-100 dark:hover:bg-neutral-800/50 dark:data-[state=selected]:bg-neutral-800', className)
  }, props));
});
TableRow.displayName = 'TableRow';
const TableHead = /*#__PURE__*/React.forwardRef((_ref6, ref) => {
  let {
    className = ''
  } = _ref6,
      props = _objectWithoutProperties(_ref6, _excluded6);

  return /*#__PURE__*/_jsx("th", _objectSpread({
    ref: ref,
    className: cn('h-12 px-4 text-left align-middle font-medium text-neutral-500 [&:has([role=checkbox])]:pr-0 dark:text-neutral-400', className)
  }, props));
});
TableHead.displayName = 'TableHead';
const TableCell = /*#__PURE__*/React.forwardRef((_ref7, ref) => {
  let {
    className = ''
  } = _ref7,
      props = _objectWithoutProperties(_ref7, _excluded7);

  return /*#__PURE__*/_jsx("td", _objectSpread({
    ref: ref,
    className: cn('p-4 align-middle [&:has([role=checkbox])]:pr-0', className)
  }, props));
});
TableCell.displayName = 'TableCell';
const TableCaption = /*#__PURE__*/React.forwardRef((_ref8, ref) => {
  let {
    className = ''
  } = _ref8,
      props = _objectWithoutProperties(_ref8, _excluded8);

  return /*#__PURE__*/_jsx("caption", _objectSpread({
    ref: ref,
    className: cn('mt-4 text-sm text-neutral-500 dark:text-neutral-400', className)
  }, props));
});
TableCaption.displayName = 'TableCaption';
export { Table, TableHeader, TableBody, TableFooter, TableHead, TableRow, TableCell, TableCaption };